export const environment = {
  production: false,
  azureAuthConfig: {
    scopes: [
      "api://appraiserpro_webapi_staging/appraiserpro_api"
    ],
    auth: {
      "clientId": "6ddb37bf-a117-469e-98b9-efcbbdf13d31",
      "authority": "https://login.microsoftonline.com/061a5b6d-ddfe-4b42-9991-5970d94cf511"
    }
  },
  apiConfig: {
    apiBaseUrl: "https://api.admin.dev.clearbasinsystems.com/api/v1/",
    validKey: "C9M3E9Q71VT2LKFY02X8GLE2PS4KXKPRDVHWGGG67J7SUAP4SJL4X7S7KRJCZMY3E3UBJ9KGHGW8KS74FNYC5EZWM9EEDMBPMYWZ",
    valuationApiBaseUrl: "https://api.valuation.staging.myappraiserpro.com/api/v1/",
    valuationValidKey: "2LUZ0DKLEKF1UDL2XRA09MZB1CQHNFZJ2ZUP00GTQRA982FBN30D83Z5C1MR4FQLEARJ3GUZDCT4HTTJEF5R6HT980ZAQSUTLG0D",
  },
};
